__turbopack_context__.v({
  "cell": "sryvja_cell",
  "dock": "sryvja_dock",
  "riseIn": "sryvja_riseIn",
  "well": "sryvja_well",
});
